import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { ChangeOrder } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type ChangeOrderModel = getEntityType<ChangeOrderState>;

export interface ChangeOrderState
  extends ActiveState,
    EntityState<
      Omit<
        RequireSome<Partial<ChangeOrder>, 'id'>,
        'approved_budget_version' | 'merged_budget_version' | 'organization' | 'workflow_details'
      > & {
        approved_budget_version?: null | {
          __typename: 'BudgetVersion';
          budget_version_id: string;
        };
        merged_budget_version?: null | {
          __typename: 'BudgetVersion';
          budget_name: string;
          budget_type: string;
          budget_version_id: string;
        };
        organization_id: string;
        verifications: ChangeOrderVerification[];
        workflow_id: string;
      }
    > {}

export interface ChangeOrderVerification {
  name: string;
  status: 'check' | 'exc-gray' | 'exc-red' | 'exc-yellow';
  value: string;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'change-order' })
export class ChangeOrderStore extends EntityStore<ChangeOrderState> {
  constructor() {
    super({});
  }
}
